import AuthorizedDashboard from "./AuthorizedDashboard";
import { AuthorizationProvider } from "meportal/AuthorizationProvider"
import React, { useState, useEffect } from "react";
import { useEventType } from "../../providers/EventTypeProvider";
import { AtaCodeProvider } from "../../providers/AtaCodeProvider";
import { logInformation } from "meportal/Logger";
import { getDatetimeUtcNowString } from "../../helpers/DateTime";
import { APP_NAME_APPINSIGHTS } from "../../constants/Constants";

function Dashboard() {
const {eventTypes, selectedEventType} = useEventType();
const [eventTypeIds, setEventTypeIds] = useState<string[]>([]);
const moduleName = `${APP_NAME_APPINSIGHTS}-Dashboard`;
console.log("Dashboard - Selected event type", selectedEventType);

useEffect(() => {
  
    const activeEventTypes = () => {
      let activeTypes = eventTypes.filter((eventType) => eventType.IsActive);
      let ids = activeTypes.map((eventType) => eventType.Airline + ":" + eventType.Name);
      setEventTypeIds(ids);
      logInformation(
        `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Loaded active event types count: ${ids.length}`,
        moduleName,
        "activeEventTypes"
      );
    }
    activeEventTypes();
  }, [eventTypes, selectedEventType]);

return (
    <AuthorizationProvider eventId={eventTypeIds}>
        <AtaCodeProvider>
            <AuthorizedDashboard />
        </AtaCodeProvider>
    </AuthorizationProvider>
);

}

export default Dashboard;